/* eslint-disable import/no-unresolved,react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useMutation } from 'react-query';
import { SecurityTOTPBodyLayout } from 'assets/components';
import { isIOS } from 'react-device-detect';
import { USER_DETAILS_UPDATE_KEY } from '../../../utilities/sharedMutations';
import { USER_VERIFY_TOTP } from '../mutations';
import { ACTIONS_AFTER_RESET_SECRET } from '../constants';
import { showAlert } from '../../../utilities/notifications';
import Input from '../../../components/Input';
import { useUsEnv } from '../../../utilities/sharedHooks/useUsEnv';
import { OAUTH_SESSION_KEYS } from '../../Oauth/constants';
import { CARD_ORDER_DEEPLINK_SESSION_KEYS } from '../../Card/deeplink/constants';
import { WITHDRAWAL_DEEPLINK_SESSION_KEYS } from '../../Accounts/deeplink/constants';
import { TOPUP_DEEPLINK_SESSION_KEYS } from '../../Accounts/topupDeeplink/constants';
import { CASHBACK_DEEPLINK_SESSION_KEYS } from '../../Card/Loyalty/deeplink/constants';
import { SET_PIN_DEEPLINK_SESSION_KEYS } from '../../Card/Settings/deeplink/constants';
import { MANAGE_ASSETS_DEEPLINK_SESSION_KEYS } from '../../Accounts/manageAssetsDeeplink/constants';

const SecurityVerifyTOTPSecret = () => {
  const { t: translate } = useTranslation();

  const [totpToken, setTotpToken] = useState('');

  const { state } = useLocation();
  const history = useHistory();

  const { isUsEnv } = useUsEnv();
  const oauthReturnUrl = sessionStorage.getItem(
    isUsEnv ? OAUTH_SESSION_KEYS.US_RETURN_URL : OAUTH_SESSION_KEYS.ROW_RETURN_URL
  );
  const withdrawalReturnUrl = sessionStorage.getItem(WITHDRAWAL_DEEPLINK_SESSION_KEYS.RETURN_URL);
  const cardOrderReturnUrl = sessionStorage.getItem(CARD_ORDER_DEEPLINK_SESSION_KEYS.RETURN_URL);
  const topupReturnUrl = sessionStorage.getItem(TOPUP_DEEPLINK_SESSION_KEYS.RETURN_URL);
  const cashbackReturnUrl = sessionStorage.getItem(CASHBACK_DEEPLINK_SESSION_KEYS.RETURN_URL);
  const setPinReturnUrl = sessionStorage.getItem(SET_PIN_DEEPLINK_SESSION_KEYS.RETURN_URL);
  const manageAssetsReturnUrl = sessionStorage.getItem(
    MANAGE_ASSETS_DEEPLINK_SESSION_KEYS.RETURN_URL
  );

  const { mutateAsync: refetchUser } = useMutation(USER_DETAILS_UPDATE_KEY);

  const { mutate: totpVerify, isLoading: isLoadingVerify } = useMutation(USER_VERIFY_TOTP, {
    onSettled: async (_, error) => {
      if (!error) {
        switch (state?.action) {
          case ACTIONS_AFTER_RESET_SECRET.LOGIN: {
            if (oauthReturnUrl) {
              history.push(oauthReturnUrl);
              return;
            }
            await refetchUser();
            if (withdrawalReturnUrl) {
              sessionStorage.removeItem(WITHDRAWAL_DEEPLINK_SESSION_KEYS.RETURN_URL);
              history.push(withdrawalReturnUrl);
              return;
            }
            if (cardOrderReturnUrl) {
              sessionStorage.removeItem(CARD_ORDER_DEEPLINK_SESSION_KEYS.RETURN_URL);
              history.push(cardOrderReturnUrl);
              return;
            }
            if (topupReturnUrl) {
              sessionStorage.removeItem(TOPUP_DEEPLINK_SESSION_KEYS.RETURN_URL);
              history.push(topupReturnUrl);
              return;
            }
            if (cashbackReturnUrl) {
              sessionStorage.removeItem(CASHBACK_DEEPLINK_SESSION_KEYS.RETURN_URL);
              history.push(cashbackReturnUrl);
              return;
            }
            if (setPinReturnUrl) {
              sessionStorage.removeItem(SET_PIN_DEEPLINK_SESSION_KEYS.RETURN_URL);
              history.push(setPinReturnUrl);
              return;
            }
            if (manageAssetsReturnUrl) {
              sessionStorage.removeItem(MANAGE_ASSETS_DEEPLINK_SESSION_KEYS.RETURN_URL);
              history.push(manageAssetsReturnUrl);
              return;
            }
            history.push(`/`, { showPromo: true, totpVerified: true });
            break;
          }
          case ACTIONS_AFTER_RESET_SECRET.RESET_PASSWORD: {
            history.push(`/onboarding/reset-password/confirm-phone-number`, {
              isTOTP: true,
              ...state,
            });
            break;
          }
          default:
            await refetchUser();
            history.push(`/`, { showPromo: true, totpVerified: true });
            break;
        }
      }
    },
    onError: (error) => {
      showAlert({ message: error.message, type: 'danger' });
    },
  });

  const handleChange = (e) => {
    if (!e) return;
    const { value } = e.target;

    setTotpToken(value);
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();

    totpVerify({ token: totpToken, email: state?.email || state?.username });
  };

  useEffect(() => {
    if (!state?.email && !state?.username) {
      history.push('/onboarding/login');
    }
  }, []);

  const renderButtons = () => (
    <button
      className="btn btn-primary w-100 py-3 text-bold"
      type="submit"
      form="verify-totp"
      disabled={!totpToken || isLoadingVerify}
      loading={isLoadingVerify ? 'true' : 'false'}>
      {translate('generic_next')}
    </button>
  );

  return (
    <SecurityTOTPBodyLayout
      renderButtons={renderButtons}
      title={translate('totp_verity_title')}
      withBack
      onPrevClick={history.goBack}>
      <form onSubmit={handleSubmitForm} id="verify-totp">
        <Input
          groupClassName={`mb-0 mt-4 ${isIOS ? 'ios' : ''}`}
          type="text"
          className={`form-control-input bg-light input-font-size ${isIOS ? 'ios' : ''}`}
          placeholder={translate('totp_verify_subtitle')}
          label={translate('totp_verify_subtitle')}
          name="totpToken"
          value={totpToken}
          onChange={handleChange}
          required
          withFloatingLabel
        />
      </form>
    </SecurityTOTPBodyLayout>
  );
};

export default SecurityVerifyTOTPSecret;
